<template>
	<div class="container">
		<div class="footer__disclaimers body-xs muted pt-150 pb-150 bt">
			<RichTextComponent :blocks="disclaimer" />
			<p> Copyright &copy; {{ currentYear }} {{ fundName }} </p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { SanityRichTextBlock } from 'types/sanity';

interface Props {
	disclaimer: Array<SanityRichTextBlock>;
	fundName: string;
}

defineProps<Props>();

const currentYear = computed((): number => {
	const today = new Date();
	return today.getFullYear();
});
</script>
